import useWindowSize from "src/hooks/useWindowSize";
import MainNavigation from "./MainNavigation";
import MobileNav from "./MobileNav";
const Navigation = () => {
  const { screen } = useWindowSize();
  return screen === "desktop" ? <MainNavigation /> : <MobileNav />;
};
export default Navigation;
